import apiURL from './apiURL'
import service from './service'


export default {
  getAlbums: function(params){
    return service.get(apiURL.albums, { params }).then(data => {
      return data
    })
  },
  getPhotoGroup: function(params){
    return service.get(apiURL.photoGroup, {
      params: {
        ...params
      }
    }).then(data => {
      return data
    })
  },
  getPhotoList: function(params){
    return service.get(apiURL.photoList, {
      params: {
        ...params,
      }
    }).then(data => {
      return data
    })
  },
  getAlbumList: function(params){
    return service.get(apiURL.albumList, {
      params: {
        ...params
      }
    })
  },
  getList: function(params){
    return service.get(apiURL.photo, {
      params: {
        ...params
      }
    }).then( res => {
      let data = res.data;
      let list = []
      if(data.photos && data.photos.length > 0){
        data.photos.forEach(item => {
          list = list.concat(item.ps)
        })
      }
      return {
        list,
        hasNext: res.hasNext,
        total: res.count
      };
    })
  },
  getCollect: function(params){
    return service.get(apiURL.collect, {
      params: {
        ...params
      }
    }).then( res => {
      return res.data;
    })
  },
  addFavorite: function(params){
    return service.post(apiURL.addFavorite, params)
  },
  removeFavorite: function(params){
    return service.delete(apiURL.removeFavorite + params.photo + '/', {'data': params})
  },
  addLike: function(params){
    return service.post(apiURL.addLike, params)
  },
  removeLike: function(params){
    return service.delete(apiURL.removeLike + params.photo + '/', {'data': params})
  },
  deletePhoto: function(params) {
    return service.delete(apiURL.deletePhoto + params.photo + '/',  {'data': params})
  },
  canDeletePhoto: function(params) {
    return service.get(apiURL.canDeletePhoto ,  { params })
  },
  getWxConfgi(url){
    return service.get(apiURL.wxConfig, {
      params: {
        url
      }
    })
  },
  qrcode: function(params) {
    return service.get(apiURL.qrcode ,  {params})
  },
  download: function(params){
    return service.get(apiURL.download, {params})
  },
  viewPhotoCount: function(params){
    return service.get(apiURL.viewPhotoCount, {params})
  }

}